import {
  updateChartColorConfigData,
  updateSimpleChartColorScheme,
  updateSimpleChartFontSizeConfigData,

  updateMultipleCrossChartColorConfigData,
  updateMultipleCrossChartColorScheme,
  updateMultipleCrossFontSizeConfigData,

  updateSimpleCrossChartColorConfigData,
  updateSimpleCrossChartColorScheme,
  updateSimpleCrossChartFontSizeConfigData,

  updateEvolutiveColorConfigData,
  updateEvolutiveChartColorScheme,
  updateEvolutiveFontSizeConfigData,

  updateEvolutiveCrossColorConfigData,
  updateEvolutiveCrossChartColorScheme,
  updateEvolutiveCrossFontSizeConfigData,

  updateCorrelationColorConfigData,
  updateCorrelationFontSizeConfigData,
  updateCorrelationChartColorScheme,
} from "src/stores/actions/charts";

import { SIMPLE_CARD,  MULTIPLE_CARD, SIMPLECROSS_CARD, EVOLUTIVE_CARD, EVOLUTIVE_CROSS_CARD, CORRELATION_CARD } from "src/sections/GroupCards/cardTypes";

const strategies = {
  [SIMPLE_CARD]: {
    updateChartColorsAction: updateChartColorConfigData,
    updateColorSchemeAction: updateSimpleChartColorScheme,
    updateFontSizeAction: updateSimpleChartFontSizeConfigData,
  },
  [MULTIPLE_CARD]: {
    updateChartColorsAction: updateMultipleCrossChartColorConfigData,
    updateColorSchemeAction: updateMultipleCrossChartColorScheme,
    updateFontSizeAction: updateMultipleCrossFontSizeConfigData,
  },
  [SIMPLECROSS_CARD]: {
    updateChartColorsAction: updateSimpleCrossChartColorConfigData,
    updateColorSchemeAction: updateSimpleCrossChartColorScheme,
    updateFontSizeAction: updateSimpleCrossChartFontSizeConfigData,
  },
  [EVOLUTIVE_CARD]: {
    updateChartColorsAction: updateEvolutiveColorConfigData,
    updateColorSchemeAction: updateEvolutiveChartColorScheme,
    updateFontSizeAction: updateEvolutiveFontSizeConfigData,
  },
  [EVOLUTIVE_CROSS_CARD]: {
    updateChartColorsAction: updateEvolutiveCrossColorConfigData,
    updateColorSchemeAction: updateEvolutiveCrossChartColorScheme,
    updateFontSizeAction: updateEvolutiveCrossFontSizeConfigData,
  },
  [CORRELATION_CARD]: {
    updateChartColorsAction: updateCorrelationColorConfigData,
    updateColorSchemeAction: updateCorrelationChartColorScheme,
    updateFontSizeAction: updateCorrelationFontSizeConfigData,
  },
};

/**
 *
 * @param {string} cardType
 * @returns {Function} action correspondente à interação de um usuário com o gráfico. Caso
 *  ocorra uma mudança no esquema de cores no card do gráfico simples, a action recuperada será
 *  de atualização de esquema de cores no gráfico simples.
 */
export default function getChartActionByCardType(cardType = SIMPLE_CARD) {
  return strategies[cardType];
}
